import React, { type FunctionComponent, type MouseEvent } from 'react'
import { CloseIcon } from '@instacart/ids-core'
import styled from '@emotion/styled'
import { spacing } from '@retailer-platform/shared-components'

interface Props {
  onCancel: (event: MouseEvent<HTMLElement>) => void
  title: string
}

const StyledFormHeader = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
})
const StyledButton = styled.button({
  background: 'transparent',
  display: 'block',
  height: '18px',
  cursor: 'pointer',
  transform: 'scale(0.7)',
})

const FormTitle = styled.div({
  fontWeight: 600,
  color: '#000',
  fontSize: '18px',
  marginBottom: spacing.X24,
  flexGrow: 1,
  display: 'flex',
  justifyContent: 'left',
})

export const FormHeader: FunctionComponent<Props> = ({ onCancel, title }) => (
  <StyledFormHeader>
    <FormTitle>{title}</FormTitle>
    <StyledButton onClick={onCancel} type="button">
      <CloseIcon size={24} />
    </StyledButton>
  </StyledFormHeader>
)
